<template>
  <v-card flat>
    <b-row>
      <b-col v-if="showServiceVisit" md="6">
        <b-form-group
          :label="$t('SERVICE_VISIT_COMMENTS.SERVICE_VISIT')"
          label-for="service-visit-input"
        >
          <FormSelect
            id="service-visit-input"
            v-model="form.serviceVisitId"
            :options="visitOptions"
            :validateState="validateState('serviceVisitId')"
          ></FormSelect>
        </b-form-group>
      </b-col>
      <b-col v-if="form.status" md="6">
        <b-form-group :label="$t('FORM_LABELS.STATUS')">
          <FormSelect
            v-if="!readonly"
            v-model="form.statusId"
            :options="statusOptions"
          ></FormSelect>
          <b-form-input v-else :value="form.status.name" disabled></b-form-input>
        </b-form-group>
      </b-col>
      <b-col md="12">
        <b-form-group
          :label="$t('SERVICE_VISIT_COMMENTS.BODY')"
          label-for="comment-body-input"
        >
          <b-form-textarea
            id="comment-body-input"
            v-model="form.body"
            rows="6"
            max-rows="10"
            maxlength="2000"
            :disabled="readonly"
            :state="validateState('body')"
          ></b-form-textarea>
        </b-form-group>
      </b-col>
    </b-row>
  </v-card>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { FETCH_SERVICE_VISIT_COMMENT_OPTIONS } from "@/modules/service-visit-comments/store/service-visit-comments.module";
import FormSelect from "@/view/content/forms/components/FormSelect.vue";

export default {
  name: "ServiceVisitCommentsForm",
  mixins: [validationMixin],
  components: { FormSelect },
  props: {
    form: { type: Object, required: true },
    showServiceVisit: { type: Boolean, default: true },
    statusOptions: { type: Array, default: () => [] },
    readonly: { type: Boolean, default: false }
  },
  data() {
    return { visitOptions: [] };
  },
  validations() {
    const fields = { body: { required } };
    if (this.showServiceVisit) fields.serviceVisitId = { required };
    return { form: fields };
  },
  mounted() {
    if (this.showServiceVisit) this.fetchVisitOptions();
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    fetchVisitOptions() {
      this.$store
        .dispatch(FETCH_SERVICE_VISIT_COMMENT_OPTIONS)
        .then(data => {
          this.visitOptions = data.data;
        })
        .catch(response => {
          this.$notify({
            group: "notify",
            type: "error",
            title: this.$t("ALERTS.ERROR"),
            text: response.data.message
          });
        });
    }
  }
};
</script>
